import { render, staticRenderFns } from "./CostSet.vue?vue&type=template&id=a2369104&scoped=true&"
import script from "./CostSet.vue?vue&type=script&lang=js&"
export * from "./CostSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2369104",
  null
  
)

export default component.exports